import { useLocation, useNavigate } from 'react-router-dom';
import Icon, { IconName } from '../design/Icon';

/* Kit tab bar: Gym · Progress · [BOOK] · Calendar · Profile.
   Book is the raised centre FAB (SPEC.md).

   Gym and Book are gym-scoped; Progress and Calendar are personal and span
   every gym the member belongs to. Check-in is no longer a tab — it lives
   behind the QR button in the Gym header, and Calendar took its slot. */

const TABS: Array<{ key: string; icon: IconName; label: string; to: string; match: string[] }> = [
  { key: 'home', icon: 'dumbbell', label: 'Gym', to: '/app', match: ['/app'] },
  { key: 'progress', icon: 'chart', label: 'Progress', to: '/app/progress', match: ['/app/progress', '/app/activity'] },
  { key: 'book', icon: 'book', label: 'Book', to: '/app/book', match: ['/app/book', '/app/bookings', '/app/classes'] },
  { key: 'calendar', icon: 'cal', label: 'Calendar', to: '/app/calendar', match: ['/app/calendar', '/app/plan', '/app/session'] },
  { key: 'profile', icon: 'user', label: 'Profile', to: '/app/profile', match: ['/app/profile', '/app/billing', '/app/plans', '/app/checkins'] },
];

export default function MTabBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isActive = (t: (typeof TABS)[number]) =>
    t.to === '/app' ? pathname === '/app' : t.match.some(m => pathname.startsWith(m));

  return (
    <nav className="tabs">
      {TABS.map(t =>
        t.key === 'book' ? (
          <button key={t.key} className="tab-mid" onClick={() => navigate(t.to)} aria-label="Book">
            <div className="fab">
              <Icon n="book" s={25} w={1.7} />
            </div>
            <span>Book</span>
          </button>
        ) : (
          <button key={t.key} className={`tab${isActive(t) ? ' on' : ''}`} onClick={() => navigate(t.to)}>
            <Icon n={t.icon} s={21} c={isActive(t) ? 'var(--ink)' : 'var(--ink-3)'} w={1.7} />
            {t.label}
          </button>
        )
      )}
    </nav>
  );
}
